import { Link as LinkComponent, NavLink as NavLinkComponent, useLocation } from 'react-router-dom'

export function useLinkNavigateTo({ to, navigateTo }) {
  const current = useLocation()
  let link = { to }
  if (navigateTo) {
    link = { to: navigateTo, state: { from: current } }
  }
  return link
}

function Link({ to, navigateTo, ...props }) {
  const { to: linkTo, state } = useLinkNavigateTo({ to, navigateTo })
  return <LinkComponent to={linkTo} state={state} {...props} />
}

export function NavLink(props) {
  return <NavLinkComponent {...props} />
}

export default Link
